import React from 'react';
import * as ReactDOM from 'react-dom';
import { compose, contains, append, reduce } from 'ramda';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';

import { Button, Link, Image, RichText } from '@synergycms_core/components/generic';
import { CSSTransition } from 'react-transition-group';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import styleFile from './footer.js';
import { connect } from 'react-redux';

const FooterLinks = compose(withThemeJSS({ styleFile, displayName: 'Footer' }))(props => {
    const { classes } = props.theme.styles;
    return (
        <div className={classes.footerInfo}>
            {props.list.map((val) =>
                <Link
                    key={val.name}
                    href={val.link}
                    target={'_blank'}
                    innerStyle={classes.footerLink}
                    richText={{
                        text: val.name,
                        translate: true,
                        ucFirst: true,
                        innerStyle: [classes.footerLinkText]
                    }}
                />
            )}
        </div>
    );
});
class Footer extends React.Component {
    static displayName = 'Footer';

    constructor(props) {
        super(props);
        this.state = {
            seeLinks: false
        };
    };

    isMobile = () => {
        return this.props.theme.deviceType !== 'DESK';
    };

    toggleLinks = e => {
        e.preventDefault();
        this.setState(state => ({
            seeLinks: !state.seeLinks
        }));
    };

    componentDidMount() {
        this.element = ReactDOM.findDOMNode(this);

        if (this.isMobile()) {
            document.addEventListener('click', this.propagateCloseDropDown);
        }
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.propagateCloseDropDown);
    }
    propagateCloseDropDown = e => {
        if (!e || (this.element && this.element.contains && document.contains && !this.element.contains(e.target) && document.contains(e.target))) {
            this.setState(state => ({
                seeLinks: false
            }));
        }
    };
    render() {
        const { theme, content, config } = this.props;
        const { classes } = theme.styles;
        const { stepCode, group } = config;
        const arrayLinks = ['AVISO_LEGAL', 'POLITICA_PRIVACIDAD', 'PROTECCION_DATOS', 'COOKIES', 'POLITICA_COOKIES', 'TERMINOS_DE_USO', 'CONDICIONES_GENERALES'];
        const objectList = reduce((acc, code) => {
            let link = content.getLinks(code);
            return (link && append({ name: '_%' + code + '%_', "link": link }, acc)) || acc;
        }, [], arrayLinks);
        return (
            (!contains(stepCode, ['cancelation']) && objectList.length >= 1 && (
                <div className={classes.footer}>
                    {!this.isMobile() && <div className={classes.footerLeftLogo}>
                        {contains(group, ['eurostarshotels', 'tandemapartments', 'eurostarshotelcompany', 'eurostarshotelsunificado']) ?
                            <Image innerStyle={classes.logoElement} svg={'hotusaGroup'} /> :
                            <Image innerStyle={classes.logoElement} svg={'keytel'} />
                        }
                    </div>}
                    <div className={classes.footerContent}>
                        {this.isMobile() &&
                            <Button
                                innerStyle={classes.footerContentTitleButton}
                                onClick={this.toggleLinks}
                                richText={{
                                    text: '_%avisos legales%_',
                                    translate: true,
                                    ucFirst: true,
                                    icon: {
                                        unicodeContent: this.state.seeLinks ? 'e0b5' : 'e0b2',
                                        innerStyle: classes.footerContentTitleIcon
                                    }
                                }} />
                        }
                        <CSSTransition
                            in={this.state.seeLinks || !this.isMobile()}
                            timeout={300}
                            mountOnEnter
                            unmountOnExit
                            classNames={{
                                enter: classes.seeLinksEnter,
                                enterActive: classes.seeLinksEnterActive,
                                exit: classes.seeLinksLeave,
                                exitActive: classes.seeLinksLeaveActive
                            }}>
                            <FooterLinks list={objectList} />
                        </CSSTransition>
                    </div>
                    {!this.isMobile() && <div className={classes.footerRightLogo}>
                        <RichText
                            innerStyle={classes.safeBuy}
                            translate={true}
                            ucFirst={true}
                            text={'_%compra segura%_'}
                        />
                    </div>}
                </div>
            )) || null
        );
    }
}
const mapStateToProps = store => {
    return {
        stepCode: store.getIn(['customer', 'step', 'current_step', 'code']),
        group: store.get("group", false)
    };
};
export default compose(
    connect(mapStateToProps),
    PropertyManager([
        'stepCode',
        'group'
    ]),
    withThemeJSS({ styleFile, link: true }),
    withContent('links')
)(Footer);